var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "48px",
    viewBox: "0 0 40 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "07558CE6-B6A8-470B-BF9B-B7712101A087") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L22.0765494,0 C24.6384132,1.30575009e-15 27.1025713,0.983224006 28.9607278,2.74685677 L36.3841785,9.79267918 C38.3734985,11.6808033 39.5,14.3031218 39.5,17.0458224 L39.5,43 C39.5,45.7614237 37.2614237,48 34.5,48 L5.5,48 C2.73857625,48 0.5,45.7614237 0.5,43 L0.5,5 C0.5,2.23857625 2.73857625,5.07265313e-16 5.5,0 Z M12.5,38.25 L27.5,38.25 C29.1568542,38.25 30.5,37.2426407 30.5,36 C30.5,34.7573593 29.1568542,33.75 27.5,33.75 L12.5,33.75 C10.8431458,33.75 9.5,34.7573593 9.5,36 C9.5,37.2426407 10.8431458,38.25 12.5,38.25 Z M12.5,29.25 L27.5,29.25 C29.1568542,29.25 30.5,28.2426407 30.5,27 C30.5,25.7573593 29.1568542,24.75 27.5,24.75 L12.5,24.75 C10.8431458,24.75 9.5,25.7573593 9.5,27 C9.5,28.2426407 10.8431458,29.25 12.5,29.25 Z M12.5,20.25 L27.5,20.25 C29.1568542,20.25 30.5,19.2426407 30.5,18 C30.5,16.7573593 29.1568542,15.75 27.5,15.75 L12.5,15.75 C10.8431458,15.75 9.5,16.7573593 9.5,18 C9.5,19.2426407 10.8431458,20.25 12.5,20.25 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04--Pedidos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-04-02-21-pedido-pr\\xE9-auto-com-doc",
    transform: "translate(-700.000000, -601.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(210.000000, 438.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(352.555682, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SiteAdvanceCare/01_Elements/Icons/System---Docs",
    transform: "translate(137.444318, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Color",
    fill: "#000000",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFiles);
export default __webpack_public_path__ + "static/media/attach-files.2e7531fc98c418d0c3ab92a4b8a277c4.svg";
export { ForwardRef as ReactComponent };